import { createAction } from '@reduxjs/toolkit'
import { ResponseShopFeeds } from '@ads/front-core/api'
import { AppState } from 'store/appState'
import { lng } from '@ads/front-core/locales'

export const setFeeds = createAction<Required<ResponseShopFeeds>>(
  'feeds/setFeeds',
)

export const setFeedsReducer = (
  state: AppState['feeds'],
  action: ReturnType<typeof setFeeds>,
): void => {
  state.list = (action.payload || []).map(feed => ({
    ...feed,
    name: feed.name
      ? feed.name
      : feed.type === 'MASTER'
      ? lng('websiteSettings:feed.mainFeedProduct')
      : '',
  }))
}
